// extracted by mini-css-extract-plugin
module.exports = {"button":"SalesforceCreateLeadButton_button__PmpVd","text":"SalesforceCreateLeadButton_text__39hq0"};